import { useSiloWeb3 } from '@silo/web3';
import posthog from 'posthog-js';
import { FC } from 'react';
import { DoApprove, QueryApproval } from '../common/ActionForm';
import { PulsePanel } from '../common/PulsePanel';
import { DoRepay, RepayForm } from './RepayForm';
import { ProtocolInstance } from '@silo/types';

type RepayPanelState =
  | { tag: 'loading' }
  // TODO: look into using React suspense for these values
  | { tag: 'loaded'; protocolInstance: ProtocolInstance };
// | { tag: 'frozen' };

const useRepayPanelState = (): RepayPanelState => {
  const { protocolInstance } = useSiloWeb3();
  if (protocolInstance === undefined) return { tag: 'loading' };

  return { tag: 'loaded', protocolInstance };
};

export interface RepayPanelProps {
  queryApproval: QueryApproval;
  doApprove: DoApprove;
  doRepay: DoRepay;
}

export const RepayPanel: FC<RepayPanelProps> = ({ queryApproval, doApprove, doRepay }) => {
  const repayPanelState = useRepayPanelState();
  const { account } = useSiloWeb3();

  switch (repayPanelState.tag) {
    case 'loading':
    default:
      return <PulsePanel />;
    case 'loaded': {
      const { protocolInstance } = repayPanelState;
      posthog.identify(account);

      return (
        <RepayForm
          protocolInstance={protocolInstance}
          queryApproval={queryApproval}
          doApprove={doApprove}
          doRepay={doRepay}
        />
      );
    }
  }
};
